// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout_Layout__nqwCk {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.Layout_Layout__nqwCk .Layout_Content__rMPJB {
  display: flex;
  flex-direction: column;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/Layout.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AACR","sourcesContent":[".Layout {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n\n    .Content {\n        display: flex;\n        flex-direction: column;\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Layout": `Layout_Layout__nqwCk`,
	"Content": `Layout_Content__rMPJB`
};
export default ___CSS_LOADER_EXPORT___;
